/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesAnswerOptions } from './WebApiModelsEnumerationTypesAnswerOptions';
import {
    WebApiModelsEnumerationTypesAnswerOptionsFromJSON,
    WebApiModelsEnumerationTypesAnswerOptionsFromJSONTyped,
    WebApiModelsEnumerationTypesAnswerOptionsToJSON,
} from './WebApiModelsEnumerationTypesAnswerOptions';
import type { WebApiModelsEnumerationTypesDisplayType } from './WebApiModelsEnumerationTypesDisplayType';
import {
    WebApiModelsEnumerationTypesDisplayTypeFromJSON,
    WebApiModelsEnumerationTypesDisplayTypeFromJSONTyped,
    WebApiModelsEnumerationTypesDisplayTypeToJSON,
} from './WebApiModelsEnumerationTypesDisplayType';
import type { WebApiModelsEnumerationTypesEventType } from './WebApiModelsEnumerationTypesEventType';
import {
    WebApiModelsEnumerationTypesEventTypeFromJSON,
    WebApiModelsEnumerationTypesEventTypeFromJSONTyped,
    WebApiModelsEnumerationTypesEventTypeToJSON,
} from './WebApiModelsEnumerationTypesEventType';
import type { WebApiModelsEnumerationTypesTimeChoice } from './WebApiModelsEnumerationTypesTimeChoice';
import {
    WebApiModelsEnumerationTypesTimeChoiceFromJSON,
    WebApiModelsEnumerationTypesTimeChoiceFromJSONTyped,
    WebApiModelsEnumerationTypesTimeChoiceToJSON,
} from './WebApiModelsEnumerationTypesTimeChoice';
import type { WebApiServicesDataTransferObjectsUserServiceCreateEventTimeDto } from './WebApiServicesDataTransferObjectsUserServiceCreateEventTimeDto';
import {
    WebApiServicesDataTransferObjectsUserServiceCreateEventTimeDtoFromJSON,
    WebApiServicesDataTransferObjectsUserServiceCreateEventTimeDtoFromJSONTyped,
    WebApiServicesDataTransferObjectsUserServiceCreateEventTimeDtoToJSON,
} from './WebApiServicesDataTransferObjectsUserServiceCreateEventTimeDto';

/**
 * Data transfer object for the M:WebApi.Services.Interfaces.IUserService.RegisterAsync(WebApi.Services.DataTransferObjects.UserService.RegisterReqDto,System.String) request.
 * @export
 * @interface WebApiServicesDataTransferObjectsUserServiceCreateEventDto
 */
export interface WebApiServicesDataTransferObjectsUserServiceCreateEventDto {
    /**
     * Gets or sets the Name.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    name?: string | null;
    /**
     * Max number of participants for event
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    maxParticipants?: number;
    /**
     * True when guests can join a waitlist once a time is fully booked.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    allowWaitlist?: boolean;
    /**
     * Max number of guests on the waitlist for each time. Null means no limit.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    maxWaitlist?: number | null;
    /**
     * True when only members of the company can sign up, by logging in or through a personal invite.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    membersOnly?: boolean;
    /**
     * True when the event is listed for logged in members on the company's public site.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    showOnMemberSite?: boolean;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEventType}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    eventType?: WebApiModelsEnumerationTypesEventType;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesTimeChoice}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    timeChoice?: WebApiModelsEnumerationTypesTimeChoice;
    /**
     * Max number of participants for event
     * @type {Date}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    deadline?: Date | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesDisplayType}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    displayType?: WebApiModelsEnumerationTypesDisplayType;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    sendAutomaticReminder?: boolean;
    /**
     * How many days before the deadline (or the first time) the automatic reminder is sent. Null means 2.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    automaticReminderDays?: number | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesAnswerOptions}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    answerOptions?: WebApiModelsEnumerationTypesAnswerOptions;
    /**
     * Gets or sets the email.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    timeZoneId?: string | null;
    /**
     * Gets or sets the password.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    description?: string | null;
    /**
     * Gets or sets the password.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    location?: string | null;
    /**
     * A list of available times
     * @type {Array<WebApiServicesDataTransferObjectsUserServiceCreateEventTimeDto>}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCreateEventDto
     */
    times?: Array<WebApiServicesDataTransferObjectsUserServiceCreateEventTimeDto> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsUserServiceCreateEventDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsUserServiceCreateEventDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsUserServiceCreateEventDtoFromJSON(json: any): WebApiServicesDataTransferObjectsUserServiceCreateEventDto {
    return WebApiServicesDataTransferObjectsUserServiceCreateEventDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsUserServiceCreateEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsUserServiceCreateEventDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'maxParticipants': !exists(json, 'maxParticipants') ? undefined : json['maxParticipants'],
        'allowWaitlist': !exists(json, 'allowWaitlist') ? undefined : json['allowWaitlist'],
        'maxWaitlist': !exists(json, 'maxWaitlist') ? undefined : json['maxWaitlist'],
        'membersOnly': !exists(json, 'membersOnly') ? undefined : json['membersOnly'],
        'showOnMemberSite': !exists(json, 'showOnMemberSite') ? undefined : json['showOnMemberSite'],
        'eventType': !exists(json, 'eventType') ? undefined : WebApiModelsEnumerationTypesEventTypeFromJSON(json['eventType']),
        'timeChoice': !exists(json, 'timeChoice') ? undefined : WebApiModelsEnumerationTypesTimeChoiceFromJSON(json['timeChoice']),
        'deadline': !exists(json, 'deadline') ? undefined : (json['deadline'] === null ? null : new Date(json['deadline'])),
        'displayType': !exists(json, 'displayType') ? undefined : WebApiModelsEnumerationTypesDisplayTypeFromJSON(json['displayType']),
        'sendAutomaticReminder': !exists(json, 'sendAutomaticReminder') ? undefined : json['sendAutomaticReminder'],
        'automaticReminderDays': !exists(json, 'automaticReminderDays') ? undefined : json['automaticReminderDays'],
        'answerOptions': !exists(json, 'answerOptions') ? undefined : WebApiModelsEnumerationTypesAnswerOptionsFromJSON(json['answerOptions']),
        'timeZoneId': !exists(json, 'timeZoneId') ? undefined : json['timeZoneId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'times': !exists(json, 'times') ? undefined : (json['times'] === null ? null : (json['times'] as Array<any>).map(WebApiServicesDataTransferObjectsUserServiceCreateEventTimeDtoFromJSON)),
    };
}

export function WebApiServicesDataTransferObjectsUserServiceCreateEventDtoToJSON(value?: WebApiServicesDataTransferObjectsUserServiceCreateEventDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'maxParticipants': value.maxParticipants,
        'allowWaitlist': value.allowWaitlist,
        'maxWaitlist': value.maxWaitlist,
        'membersOnly': value.membersOnly,
        'showOnMemberSite': value.showOnMemberSite,
        'eventType': WebApiModelsEnumerationTypesEventTypeToJSON(value.eventType),
        'timeChoice': WebApiModelsEnumerationTypesTimeChoiceToJSON(value.timeChoice),
        'deadline': value.deadline === undefined ? undefined : (value.deadline === null ? null : value.deadline.toISOString()),
        'displayType': WebApiModelsEnumerationTypesDisplayTypeToJSON(value.displayType),
        'sendAutomaticReminder': value.sendAutomaticReminder,
        'automaticReminderDays': value.automaticReminderDays,
        'answerOptions': WebApiModelsEnumerationTypesAnswerOptionsToJSON(value.answerOptions),
        'timeZoneId': value.timeZoneId,
        'description': value.description,
        'location': value.location,
        'times': value.times === undefined ? undefined : (value.times === null ? null : (value.times as Array<any>).map(WebApiServicesDataTransferObjectsUserServiceCreateEventTimeDtoToJSON)),
    };
}

